export default __webpack_public_path__ + "static/media/logo.092b2430.svg";